import { Point } from '../classes/index';

export const IOU_THRESHOLD = 0.4;

export const BOX_ANCHORS = [
  new Point(1.603231, 2.094468),
  new Point(6.041143, 7.080126),
  new Point(2.882459, 3.518061),
  new Point(4.266906, 5.178857),
  new Point(9.041765, 10.66308),
];

export const MEAN_RGB: [number, number, number] = [117.001, 114.697, 97.404];
